import { render, staticRenderFns } from "./404.vue?vue&type=template&id=ad462bb4&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=ad462bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad462bb4",
  null
  
)

export default component.exports